exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".button-group {\n  display: -ms-flexbox;\n  display: flex; }\n  .button-group .button-container {\n    -ms-flex-positive: 1;\n        flex-grow: 1; }\n\n.button-group--horizontal .button-container + .button-container {\n  margin-left: 10px; }\n\n.button-group--vertical {\n  -ms-flex-direction: column;\n      flex-direction: column; }\n  .button-group--vertical .button-container + .button-container {\n    margin-top: 20px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /root/social-native/socialnative-web/node_modules/css-loader!/root/social-native/socialnative-web/node_modules/postcss-loader/src??ref--4-2!/root/social-native/socialnative-web/node_modules/sass-loader/lib/loader.js!./components/button_group/index.scss
// module id = 2468
// module chunks = 69